var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarlyLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 10L20.3669 6.32828L11.9812 4L11.2613 6.49041L2.61621 36.1873L11.0019 38.5221L17.6667 16.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6271 8.26083L11.0342 7.26855",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 10.8489L10.282 9.8501",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1225 13.4363L9.52307 12.4375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3703 16.0241L8.77087 15.0254",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6115 18.6116L8.01855 17.6128",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8592 21.1994L7.26624 20.2007",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1069 23.7873L6.51392 22.7886",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35454 26.3747L5.7616 25.376",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60222 28.9558L5.00928 27.957",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8499 31.5437L4.25696 30.5449",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09746 34.1316L3.50452 33.1328",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9322 9.70067L14.0952 14.2405C14.0399 14.2841 13.9965 14.3412 13.9693 14.4062C13.9421 14.4713 13.9319 14.5422 13.9397 14.6123C13.9475 14.6824 13.9729 14.7493 14.0138 14.8068C14.0546 14.8643 14.1094 14.9105 14.1731 14.9409L20.8401 18.1836L45.4849 15.6284C45.6641 15.6106 45.838 15.5574 45.9965 15.472C46.1551 15.3865 46.2951 15.2705 46.4085 15.1305C46.5219 14.9906 46.6064 14.8296 46.6572 14.6568C46.7079 14.4839 46.7239 14.3028 46.7041 14.1237L46.0556 8.37114C46.0148 8.0117 45.834 7.68284 45.5523 7.45582C45.2707 7.2288 44.9108 7.12193 44.5509 7.15836L19.9322 9.70067Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1126 18.1448L20.1917 9.6748",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6664 16.115L39.7455 7.64502",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8712 16.1342L16.4756 12.5088",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1437 15.8621L42.2228 7.39209",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1096 14.6347C34.188 14.3172 36.5994 13.2452 36.4957 12.2405C36.3921 11.2357 33.8126 10.6787 30.7343 10.9963C27.6559 11.3138 25.2444 12.3858 25.3481 13.3905C25.4517 14.3953 28.0313 14.9523 31.1096 14.6347Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7445 42.0889C25.8621 42.0889 26.768 41.183 26.768 40.0655C26.768 38.9479 25.8621 38.042 24.7445 38.042C23.627 38.042 22.7211 38.9479 22.7211 40.0655C22.7211 41.183 23.627 42.0889 24.7445 42.0889Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1132 31.907C31.7507 31.907 32.2676 31.3901 32.2676 30.7526C32.2676 30.115 31.7507 29.5981 31.1132 29.5981C30.4756 29.5981 29.9587 30.115 29.9587 30.7526C29.9587 31.3901 30.4756 31.907 31.1132 31.907Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8498 38.6777L40.2123 22.062C40.3852 21.8081 40.4929 21.5154 40.5257 21.21C40.5585 20.9046 40.5155 20.5957 40.4004 20.3109L38.6818 16.037C38.6575 15.9793 38.6181 15.9292 38.5678 15.8919C38.5176 15.8545 38.4583 15.8313 38.396 15.8247C38.3338 15.8181 38.2709 15.8283 38.214 15.8542C38.157 15.8801 38.108 15.9209 38.0721 15.9721L24.5499 35.7398C23.6402 35.7801 22.7663 36.1056 22.0519 36.6701C21.3374 37.2347 20.8188 38.0097 20.5693 38.8854C20.3198 39.7612 20.3521 40.6932 20.6617 41.5495C20.9713 42.4058 21.5424 43.143 22.2943 43.6567C23.0461 44.1704 23.9405 44.4346 24.8508 44.4117C25.761 44.3889 26.641 44.0802 27.3662 43.5295C28.0913 42.9788 28.6248 42.2138 28.891 41.3431C29.1573 40.4723 29.1429 39.5398 28.8498 38.6777V38.6777Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0437 39.1773C41.1613 39.1773 42.0672 38.2714 42.0672 37.1538C42.0672 36.0363 41.1613 35.1304 40.0437 35.1304C38.9262 35.1304 38.0203 36.0363 38.0203 37.1538C38.0203 38.2714 38.9262 39.1773 40.0437 39.1773Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2155 31.5306L19.1022 25.9855C18.8494 25.8113 18.6433 25.5777 18.5019 25.3052C18.3606 25.0326 18.2883 24.7295 18.2915 24.4225L18.3434 19.8179C18.3458 19.7548 18.3649 19.6935 18.3987 19.6402C18.4325 19.5869 18.4798 19.5435 18.5359 19.5145C18.5919 19.4855 18.6547 19.4719 18.7177 19.4751C18.7808 19.4782 18.8418 19.498 18.8947 19.5325L30.0366 27.1529",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.81 30.4219L38.6558 33.0485C39.5179 32.7554 40.4504 32.7409 41.3212 33.0072C42.192 33.2735 42.9569 33.807 43.5077 34.5321C44.0584 35.2572 44.367 36.1373 44.3898 37.0475C44.4127 37.9578 44.1486 38.8522 43.6349 39.604C43.1212 40.3559 42.384 40.927 41.5277 41.2366C40.6713 41.5462 39.7393 41.5785 38.8636 41.329C37.9879 41.0795 37.2128 40.5608 36.6483 39.8464C36.0837 39.132 35.7582 38.258 35.7179 37.3483L31.9888 34.7996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyLearning);
export default __webpack_public_path__ + "static/media/early-learning.511773d8.svg";
export { ForwardRef as ReactComponent };